import api from "../utils/axios/axiosConfig";

const paymentMethodsService = {
  get: () => api.get("/admin/payment-methods/get"),
  update: (data) => api.post("/admin/payment-methods/update", data),
};

export default paymentMethodsService;
